import { APIDescriptor } from "../../types";

const baseUrl: string = "/products/beyond-sandbox/api-reference";

const descriptors: APIDescriptor[] = [
        {
            name: "Custodial Wallet Provider API",
            description: "Data capture and reporting of Custodial Wallet Provider activity",
            path: "/virtual-assets/custodial-wallet-provider",
            categories: [ { label: "Virtual Assets" } ]
        },
        {
            name: "Exchange API",
            description: "Data capture and reporting of Exchange activity",
            path: "/virtual-assets/exchange",
            categories: [ { label: "Virtual Assets" } ]
        },
        {
            name: "Issuer API",
            description: "Data capture and reporting of Issuer activity",
            path: "/virtual-assets/issuer",
            categories: [ { label: "Virtual Assets" } ]
        },
        {
            name: "Payment Service Provider API",
            description: "Data capture and reporting of Payment Service Provider activity",
            path: "/virtual-assets/payment-service-provider",
            categories: [ { label: "Virtual Assets" } ]
        },
    {
        name: "Crowdfunding Compliance API",
        description: "Data capture and reporting of Crowdfunding market activity",
        path: "/crowdfunding",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Microlending Compliance API",
        description: "Data capture and reporting of Microlending market activity",
        path: "/microlending",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Other Service API",
        description: "Data capture and reporting of transactions for other types of services",
        path: "/other",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Payment Service API",
        description: "Data capture and reporting of payments in fiat or virtual currencies",
        path: "/payment-service",
        categories: [ { label: "Traditional finance" } ]
    },
    {
        name: "Remittance APIs",
        description: "Data capture and reporting of cross border remittance transfers",
        path: "/remittance",
        categories: [ { label: "Traditional finance" } ]
    }
]

export const apiDescriptors = descriptors.map((desc) => ({ ...desc, path: baseUrl + desc.path }))
